// Item Img
import img1 from '../../assets/img/causes/causes-1.png'
import img2 from '../../assets/img/causes/causes-2.png'
import img3 from '../../assets/img/causes/causes-3.png'
import img4 from '../../assets/img/causes/causes-4.png'
import img5 from '../../assets/img/causes/causes-5.png'
import img6 from '../../assets/img/causes/causes-6.png'

// Import Icon
import Icon from "../../assets/img/icon/cal.png"
import Icon1 from "../../assets/img/icon/user.png"





export const CausesData = [
    {
        img: img1,
        category:"Food & water",
        goal:"$10,000",
        heading: "Collect fund for drinking water & healthy food",
        para:`Lorem ipsum dolor sit amet, consectetur notted
        adipisicing elit sed do eiusmod tempor.`,
        IconAdmin:Icon,
        DateIcon:Icon1
    },
    {
        img: img2,
        category:"Education",
        goal:"$10,000",
        heading: "Give children a good education & better life",
        para:`Lorem ipsum dolor sit amet, consectetur notted
        adipisicing elit sed do eiusmod tempor.`,
        IconAdmin:Icon,
        DateIcon:Icon1
    },
    {
        img: img3,
        category:"Home & shelter",
        goal:"$10,000",
        heading: "Collect fund for drinking water & healthy food",
        para:`Lorem ipsum dolor sit amet, consectetur notted
        adipisicing elit sed do eiusmod tempor.`,
        IconAdmin:Icon,
        DateIcon:Icon1
    },
    {
        img: img4,
        category:"Education",
        goal:"$10,000",
        heading: "Ensure pure and mineral drinking water for rural people",
        para:`Lorem ipsum dolor sit amet, consectetur notted
        adipisicing elit sed do eiusmod tempor.`,
        IconAdmin:Icon,
        DateIcon:Icon1
    },
    {
        img: img5,
        category:"Wild animal",
        goal:"$10,000",
        heading: "Ensure a secure and free life for the wild animal",
        para:`Lorem ipsum dolor sit amet, consectetur notted
        adipisicing elit sed do eiusmod tempor.`,
        IconAdmin:Icon,
        DateIcon:Icon1
    },
    {
        img: img6,
        category:"Home & shelter",
        goal:"$10,000",
        heading: "Stop early marriage and educate your girl child",
        para:`Lorem ipsum dolor sit amet, consectetur notted
        adipisicing elit sed do eiusmod tempor.`,
        IconAdmin:Icon,
        DateIcon:Icon1
    }
]